
<table class="dln-dt-calendar-table">
    <thead class="dln-dt-calendar-header">
    <tr class="dln-dt-weekdays">
        <th *ngFor="let weekday of weekdays"
            [attr.aria-label]="weekday.long"
            class="dln-dt-weekday" scope="col">
            <span>{{weekday.short.toUpperCase()}}</span>
        </th>
    </tr>
    </thead>
    <tbody dln-date-time-calendar-body role="grid"
           [rows]="days" [todayValue]="todayDate"
           [selectedValues]="selectedDates"
           [selectMode]="selectMode"
           [activeCell]="activeCell"
           [eventMode]="eventMode" [events]="events"
           (keydown)="handleCalendarKeydown($event)"
           (selectedValueChange)="dateSelected($event)">
    </tbody>
</table>
